import React, { useState } from "react";
import { CloseButton, FadeFloatWrapper } from "../FloatWrapper";
import { Box, CircularProgress, Stack } from "@mui/material";
import { Color, FontStyle, JobDisplays } from "../../constants";
import FettiLongInput from "../FettiLongInput";
import CharsleftDisplay from "../CharsleftDisplay";
import { MainButton } from "../../utils/buttonUtils";
import FettiLabeledCheckbox from "../FettiComponents.js/FettiLabeledCheckbox";
import * as apiService from "../../service/ApiService";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useDispatch, useSelector } from "react-redux";
import { removeLocalJobById } from "../../utils/actionUtils";

const styles = {
  outer: {
    width: "100%",
    maxHeight: "80%",
    // height: "100%",
    position: "relative",
  },
  container: {
    width: "100%",
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    padding: JobDisplays.padding,
    ...FontStyle.body,
    minWidth: "",
    // maxHeight: windowMinusNavbar,
    overflowY: "scroll",
  },
};

const ReportJobFloat = ({ show, job, handleClose }) => {
  const {
    jobId,
    company,
    jobTitle,
    location,
    locations,
    roleToken,
    experienceLevel,
    jobDescription,
    url,
    vidUrl,
    vidSize,
  } = job;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [comments, setComments] = useState("");
  const [requestHide, setRequestHide] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const wrappedClose = () => {
    if (isSuccess && requestHide) {
      removeLocalJobById(dispatch, jobId);
    }
    setComments("");
    setRequestHide(true);
    setIsError(false);
    setIsSuccess(false);
    handleClose();
  };
  const handleSubmit = () => {
    setLoading(true);
    apiService.reportJob(
      dispatch,
      null,
      {
        jobId,
        ...auth.accountData,
        jobId,
        title: jobTitle,
        comments,
        hide: requestHide,
      },
      {
        handleSuccess: () => {
          setIsSuccess(true);
        },
        handleError: () => {
          setIsError(true);
        },
        handleFinish: () => {
          setLoading(false);
        },
      }
    );
  };
  return (
    <FadeFloatWrapper
      show={show}
      onClick={() => {
        if (!loading) {
          wrappedClose();
        }
      }}>
      {isSuccess ? (
        <Stack
          sx={{
            ...styles.outer,
            maxWidth: "450px",
            px: 3,
          }}
          direction="row"
          spacing={2}
          onClick={(e) => {
            e.stopPropagation();
          }}>
          <Stack
            sx={{
              ...styles.container,
            }}
            direction="column"
            alignItems="center"
            justifyContent="center"
            spacing={2}>
            <CheckCircleIcon
              sx={{ color: Color.mainGreen, width: "40px", height: "40px" }}
            />
            <Box sx={{ paddingBottom: "4px" }}>
              Success! Thank you for your feedback.
            </Box>
            <MainButton
              disableGrow
              onClick={wrappedClose}
              sx={{
                width: "100%",
                height: "39px",
              }}>
              Back to Jobs
            </MainButton>
          </Stack>
        </Stack>
      ) : (
        <Stack
          sx={{
            ...styles.outer,
            maxWidth: "600px",
            px: 3,
          }}
          direction="row"
          spacing={2}
          onClick={(e) => {
            e.stopPropagation();
          }}>
          <Stack
            sx={{
              ...styles.container,
            }}
            direction="column"
            alignItems="center"
            justifyContent="center"
            spacing={2}>
            <Box
              sx={{
                ...FontStyle.headingBody,
                fontSize: "18px",
                width: "100%",
              }}>
              Issue with this job?{" "}
              <span style={{ fontWeight: 400 }}>Let us know.</span>
            </Box>
            <Stack
              sx={{ ...FontStyle.body, fontSize: "14px", width: "100%" }}
              spacing={0.5}
              direction="column">
              <Box sx={{ ...FontStyle.body, fontSize: "16px" }}>{jobTitle}</Box>
              <Box sx={{ ...FontStyle.body, fontSize: "14px" }}>{company}</Box>
              <Box sx={{ ...FontStyle.body, fontSize: "14px" }}>
                {locations ? locations.join(" • ") : location}
              </Box>
            </Stack>
            <Stack
              spacing={0.5}
              direction="column"
              sx={{
                width: "100%",
              }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{
                  ...FontStyle.headingBody,
                  fontSize: "14px",
                  width: "100%",
                }}>
                Feedback
                <CharsleftDisplay
                  value={comments}
                  maxLength={200}
                  threshold={20}
                />
              </Stack>
              <FettiLongInput
                value={comments}
                onChange={(e) => {
                  setComments(e.target.value);
                }}
                placeholder="Please describe the issue. Your feedback is greatly appreciated!"
                maxLength={200}
                rows={5}
                style={{
                  resize: "none",
                }}
              />
            </Stack>
            <Box sx={{ width: "100%" }}>
              <FettiLabeledCheckbox
                label="Hide this job from my feed"
                value={requestHide}
                onClick={() => setRequestHide(!requestHide)}
              />
            </Box>
            {isError && (
              <Box
                sx={{
                  ...FontStyle.body,
                  fontSize: "14px",
                  color: "red",
                  width: "100%",
                  paddingLeft: "2px",
                }}>
                {" "}
                An error occurred. Please try again later.{" "}
              </Box>
            )}
            <MainButton
              disableGrow
              disabled={comments.length <= 2 || loading}
              onClick={handleSubmit}
              sx={{
                width: "100%",
                height: "39px",
                //   py: "7px",
                //   fontSize: "14px",
                //   width: "72px",
              }}>
              {loading ? <CircularProgress size="20px" /> : "Submit"}
            </MainButton>
          </Stack>
        </Stack>
      )}
      <CloseButton onClick={wrappedClose} />
    </FadeFloatWrapper>
  );
};

export default ReportJobFloat;
